<div *ngIf="!activeViewComponent; else dynamicNotificationContainer">
    <router-outlet></router-outlet>
</div>

<ng-template #dynamicNotificationContainer></ng-template>



